import {Button, Flex, Text} from '@mantine/core'
import {IconDeviceLaptop, IconMoon, IconSun} from '@tabler/icons-react'
import {useLocalSettings} from '../../providers/localSettings/useLocalSettings.ts'

export const ColorSchemeSwitchButton = () => {
  const {setColorScheme, colorScheme} = useLocalSettings()

  return (
    <Button.Group variant={'default'}>
      <Button
        variant={colorScheme === 'light' ? 'filled' : 'default'}
        h={60}
        p={0}
        onClick={() => setColorScheme('light')}
        title={'Use light mode'}
      >
        <Flex direction={'column'} align={'center'} gap={5} w={75}>
          <IconSun stroke={1} />
          <Text size={'xs'}>Light</Text>
        </Flex>
      </Button>

      <Button
        variant={colorScheme === 'dark' ? 'filled' : 'default'}
        h={60}
        p={0}
        onClick={() => setColorScheme('dark')}
        title={'Use dark mode'}
      >
        <Flex direction={'column'} align={'center'} gap={5} w={75}>
          <IconMoon stroke={1} />
          <Text size={'xs'}>Dark</Text>
        </Flex>
      </Button>

      <Button
        variant={colorScheme === 'auto' ? 'filled' : 'default'}
        h={60}
        p={0}
        onClick={() => setColorScheme('auto')}
        title={"Use system's color scheme"}
      >
        <Flex direction={'column'} align={'center'} gap={5} w={75}>
          <IconDeviceLaptop stroke={1} />
          <Text size={'xs'}>System</Text>
        </Flex>
      </Button>
    </Button.Group>
  )
  // return (
  //   <ActionIcon.Group variant={'default'}>
  //     <ActionIcon
  //       variant={colorScheme === 'light' ? 'filled' : 'default'}
  //       size={'xl'}
  //       p={5}
  //       onClick={() => setColorScheme('light')}
  //       title={'Use light mode'}
  //     >
  //       <IconSun stroke={1} />
  //     </ActionIcon>
  //
  //     <ActionIcon
  //       variant={colorScheme === 'dark' ? 'filled' : 'default'}
  //       size={'xl'}
  //       p={5}
  //       onClick={() => setColorScheme('dark')}
  //       title={'Use dark mode'}
  //     >
  //       <IconMoon stroke={1} />
  //     </ActionIcon>
  //
  //     <ActionIcon
  //       variant={colorScheme === 'auto' ? 'filled' : 'default'}
  //       size={'xl'}
  //       p={5}
  //       onClick={() => setColorScheme('auto')}
  //       title={'Use system\'s color scheme'}
  //     >
  //       <IconDeviceLaptop stroke={1} />
  //     </ActionIcon>
  //   </ActionIcon.Group>
  // )
}
